import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CostCenterFindInterface } from '@zaoblako/shared/modules/catalog/dtos/cost-center/cost-center-find.dto';
import {
  CostCenterFormDto,
  CostCenterFormInterface
} from '@zaoblako/shared/modules/catalog/dtos/cost-center/cost-center-form.dto';
import { BasisCostCenterService } from '@zaoblako/web/core/services/basis/basis-cost-center.service';
import { ConfirmDialogService } from '@zaoblako/web/core/services/confirm-dialog.service';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { FormType } from '@zaoblako/web/shared/components/form-sidebar/models/form-state';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { BaseFormComponent } from '@zaoblako/web/shared/dumbs/base-form/base-form.component';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { CardModule } from 'primeng/card';
import { Observable } from 'rxjs';

@Component({
  selector: 'crm-cost-center-form',
  standalone: true,
  imports: [CommonModule, InputTextComponent, JoinPipe, CardModule, SpinnerComponent, ButtonComponent],
  templateUrl: './cost-center-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CostCenterFormComponent extends BaseFormComponent<CostCenterFormInterface> implements OnInit {
  @Input() public readonly index: number;
  public costCenter: CostCenterFormInterface = <any>{};

  public dto = CostCenterFormDto;
  public form$: Observable<FormType>;
  public loading$: Observable<boolean>;

  public constructor(
    private readonly basisCostCenterService: BasisCostCenterService,
    private readonly formStoreService: FormStoreService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly errorService: ErrorService,
    private readonly confirmService: ConfirmDialogService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.form$ = this.formStoreService.select((state) => state.forms[this.index]);
    this.loading$ = this.formStoreService.select((state) => state.forms[this.index]?.loading);

    if (this.formStoreService.getState.forms[this.index]?.isEdit) {
      this.getById();
    }
  }

  public getById() {
    this.formStoreService.setLoading(true, this.index);

    this.basisCostCenterService
      .findById<CostCenterFindInterface>(this.formStoreService.getState.forms[this.index]?.entityId)
      .subscribe({
        next: (costCenter) => {
          this.costCenter = costCenter;
          this.formStoreService.setLoading(false, this.index);
          this.cdRef.markForCheck();
        }
      });
  }

  public saveCostCenter() {
    if (this.checkValidate(this.costCenter).valid) {
      if (this.formStoreService.getState.forms[this.index]?.entityId) {
        this.formStoreService.setLoading(true, this.index);

        this.basisCostCenterService
          .update<CostCenterFormInterface, CostCenterFindInterface>(this.costCenter)
          .subscribe({
            next: (costCenter) => {
              this.formStoreService.setLoading(false, this.index);
              this.errorService.addSuccessMessage(`Центр затрат "${this.costCenter.name}" обновлен`);
              this.formStoreService.saveNext(costCenter, this.index);
            },
            error: () => {
              this.formStoreService.setLoading(false, this.index);
            }
          });
      } else {
        this.formStoreService.setLoading(true, this.index);

        this.basisCostCenterService.create<CostCenterFindInterface>(this.costCenter).subscribe({
          next: (costCenter) => {
            this.formStoreService.setLoading(false, this.index);
            this.errorService.addSuccessMessage('Центр затрат создан');
            this.formStoreService.saveNext(costCenter, this.index);
          },
          error: () => {
            this.formStoreService.setLoading(false, this.index);
          }
        });
      }
    }
  }

  public deleteCostCenter() {
    this.confirmService.confirm({
      message: `Вы действительно хотите удалить центр затрат "${this.costCenter.name}"?`,
      accept: () => {
        this.formStoreService.setLoading(true, this.index);
        this.cdRef.markForCheck();

        this.basisCostCenterService.deleteById(this.formStoreService.getState.forms[this.index]?.entityId).subscribe({
          next: () => {
            this.errorService.addSuccessMessage(`Центр затрат "${this.costCenter.name}" удален`);
            this.formStoreService.deleteNext(this.index);
          },
          error: () => {
            this.formStoreService.setLoading(false, this.index);
          }
        });
      }
    });
  }

  public restoreCostCenter() {
    this.confirmService.confirm({
      message: `Вы действительно хотите восстановить центр затрат "${this.costCenter.name}"?`,
      accept: () => {
        this.formStoreService.setLoading(true, this.index);
        this.cdRef.markForCheck();

        this.basisCostCenterService.restore(this.formStoreService.getState.forms[this.index]?.entityId).subscribe({
          next: () => {
            this.costCenter = { ...this.costCenter, deleted: false } as any;
            this.cdRef.markForCheck();
            this.errorService.addSuccessMessage(`Центр затрат "${this.costCenter.name}" восстановлен`);
            this.formStoreService.saveNext(this.costCenter, this.index);
          },
          error: () => {
            this.formStoreService.setLoading(false, this.index);
          }
        });
      }
    });
  }
}
